import { Component, createRef } from 'react'
import { map, forEach } from 'lodash'
import { connect } from 'react-redux'
import NotificationSystem from 'react-notification-system'
import { removeToast } from '../actions/toast_actions'

class ToasterContainer extends Component {
  constructor(props) {
    super(props)
    this.addedToasts = {}
    this.$notificationSystemRef = createRef()
  }

  system() {
    return this.$notificationSystemRef.current
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { toasts } = this.props
    const toastIds = map(toasts, toast => toast.uid)
    // get notifications currently in the system
    const systemNotifications = this.system().state.notifications || []

    if (toasts.length > 0) {
      // Get all active notifications from the react-notification-system
      /// and remove all where uid is not included in current toasts
      forEach(systemNotifications, notification => {
        if (toastIds.indexOf(notification.uid) < 0) {
          this.system().removeNotification(notification.uid)
        }
      })
      this.addNotifications(toasts)
    }

    if (prevProps.toasts !== toasts && toasts.size === 0) {
      this.system().clearNotifications()
    }
  }

  addNotifications(toasts = []) {
    forEach(toasts, toast => {
      this.addNotification(toast)
    })
  }

  addNotification(toast) {
    if (!toast.message || !toast.level) throw new Error('Expected toast to have a message and a level')
    if (this.system()) {
      this.system().addNotification({
        ...toast,
        onRemove: () => {
          const { onRemoveToast } = this.props
          onRemoveToast(toast.uid)
          toast.onRemove && toast.onRemove()
        },
      })
    }
  }

  render() {
    return <NotificationSystem ref={this.$notificationSystemRef} style={false} />
  }
}

function mapStateToProps(state) {
  return {
    toasts: state.data.toasts,
  }
}

function mapDispatchToProps(dispatch, props) {
  return {
    onRemoveToast: uid => {
      dispatch(removeToast(uid))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ToasterContainer)
